module.exports = __webpack_public_path__ + "img/IMG_1648.fadea06b.jpg";